import { Box, CircularProgress } from "@mui/material";
import { BoxProps } from "@mui/system";
import React from "react";

const LoadingBox = (props: BoxProps): JSX.Element => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      {...props}
    >
      <CircularProgress size="5vh" />
    </Box>
  );
};

export default LoadingBox;
